module.exports = __webpack_public_path__ + "img/Comic01-4.a0819798.png";